<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <SportipsButton backButton chevronLeft>Retour</SportipsButton>
                    <div class="text-h6 font-weight-bold mt-3 mb-2">Personnaliser l'affichage</div>
                    <div class="text-body-2 text-medium-emphasis mb-4">
                        Couleurs du module d'inscription. Laissez un champ vide pour conserver la valeur par défaut
                        Sportips.
                    </div>

                    <v-progress-linear v-if="loading" indeterminate color="primary-dark" class="mb-4" />

                    <v-alert v-if="loadError" type="error" variant="tonal" class="mb-4" density="compact">
                        Impossible de charger la personnalisation du module.
                    </v-alert>

                    <v-alert v-if="saveError" type="error" variant="tonal" class="mb-4" density="compact">
                        {{ saveError }}
                    </v-alert>

                    <v-alert v-if="saveSuccess" type="success" variant="tonal" class="mb-4" density="compact">
                        Personnalisation enregistrée.
                    </v-alert>

                    <v-row>
                        <v-col cols="12" md="8">
                            <div v-if="!loading && !loadError" class="d-flex flex-column ga-4">
                                <div v-for="field in colorFields" :key="field.key"
                                    class="d-flex flex-wrap align-center ga-3 pa-3 rounded color-row">
                                    <div class="flex-grow-1" style="min-width: 12rem;">
                                        <div class="font-weight-bold">{{ field.label }}</div>
                                        <div class="text-body-2 text-medium-emphasis">{{ field.hint }}</div>
                                        <div class="text-caption text-medium-emphasis mt-1">
                                            Défaut : {{ defaults[field.key] || '—' }}
                                        </div>
                                    </div>
                                    <div class="d-flex align-center ga-2 flex-wrap">
                                        <v-menu :close-on-content-click="false" location="bottom">
                                            <template v-slot:activator="{ props: menuProps }">
                                                <v-text-field v-model="formColors[field.key]" v-bind="menuProps"
                                                    density="compact" hide-details placeholder="#RRGGBB" width="120px"
                                                    @update:model-value="onPreview">
                                                    <template v-slot:prepend-inner>
                                                        <div class="color-swatch"
                                                            :style="{ backgroundColor: swatchColor(field.key) }" />
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-color-picker v-model="formColors[field.key]" hide-inputs show-swatches
                                                @update:model-value="onPreview" />
                                        </v-menu>
                                        <SportipsButton icon="mdi-close" @click="clearField(field.key)">Effacer
                                        </SportipsButton>
                                    </div>
                                </div>

                                <div class="text-h6 font-weight-bold mt-4 mb-2">Bandeaux</div>
                                <div class="text-body-2 text-medium-emphasis mb-3">
                                    Bandeau haut et bas du module (dimensions : 1190x250px. h-max=250px)
                                </div>

                                <div v-for="slot in bannerSlots" :key="slot.position"
                                    class="d-flex flex-column ga-3 pa-3 rounded color-row">
                                    <div class="font-weight-bold">{{ slot.label }}</div>
                                    <div v-if="formBanners[slot.position].url">
                                        <img :src="formBanners[slot.position].url" :alt="slot.label"
                                            class="banner-preview" />
                                        <div class="d-flex flex-wrap ga-2">
                                            <SportipsButton icon="mdi-delete" :loading="bannerRemoving[slot.position]"
                                                @click="removeBanner(slot.position)">
                                                Supprimer l'image
                                            </SportipsButton>
                                            <SportipsButton icon="mdi-upload"
                                                @click="startReplaceBanner(slot.position)">
                                                Remplacer
                                            </SportipsButton>
                                        </div>
                                    </div>
                                    <v-file-input v-if="!formBanners[slot.position].url || bannerReplace[slot.position]"
                                        density="compact" accept="image/*" hide-details show-size
                                        :label="slot.uploadLabel" :loading="bannerUploading[slot.position]"
                                        :error-messages="bannerErrors[slot.position]"
                                        @update:model-value="(file) => uploadBanner(slot.position, file)" />
                                    <v-switch v-model="formBanners[slot.position].in_card" density="compact"
                                        hide-details color="primary-dark" label="Afficher dans une carte" />
                                </div>

                                <div class="d-flex flex-wrap ga-2 mt-2">
                                    <SportipsButton actionButton icon="mdi-content-save" :loading="saving"
                                        @click="save">
                                        Enregistrer
                                    </SportipsButton>

                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="pa-3 rounded">
                                <div class="text-h6 font-weight-bold mb-2">Aperçu</div>
                                <div class="text-body-2 text-medium-emphasis mb-4">
                                    Aperçu de la personnalisation du module.
                                </div>
                                <div class="d-flex flex-column ga-2">
                                    <SportipsButton icon="mdi-file-document" chevron secondary-action-button>Bouton
                                        primaire
                                    </SportipsButton>

                                    <SportipsButton icon="mdi-information" actionButton chevron>Bouton secondaire
                                    </SportipsButton>
                                    <SportipsButton icon="mdi-information">Icon primary + bg cartes
                                    </SportipsButton>

                                    <div class="text-h6 font-weight-bold">Un titre de la couleur titres</div>
                                    <div>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</div>

                                    <div class="spo-card pa-3 rounded">
                                        <div class="text-h6">Une carte</div>
                                        <div>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
                                        </div>
                                        <div class="d-flex flex-row flex-wrap ga-2">
                                            <SportipsButton icon="mdi-file-document" chevron secondary-action-button>
                                                Bouton
                                                primaire
                                            </SportipsButton>

                                            <SportipsButton icon="mdi-information" actionButton chevron>Bouton
                                                secondaire
                                            </SportipsButton>
                                            <SportipsButton icon="mdi-information">Icon primary + bg cartes
                                            </SportipsButton>
                                        </div>

                                    </div>
                                    <div
                                        class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 py-2 radius-bottom mt-5">

                                        <div class="text-h5 font-weight-bold">Carte bleu gris</div>
                                    </div>
                                </div>

                            </div>
                        </v-col>
                    </v-row>


                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import AdminService from '@/services/admin.service';
import {
    DEFAULT_MODULE_COLORS,
    PERSONALIZABLE_COLOR_KEYS,
    withSyncedPrimaryDark,
} from '@/config/moduleColors';
import { applyModuleTheme } from '@/utils/applyModuleTheme';

function emptyFormColors() {
    const out = {};
    PERSONALIZABLE_COLOR_KEYS.forEach(({ key }) => {
        out[key] = '';
    });
    return out;
}

function emptyFormBanners() {
    return {
        top: { url: '', in_card: false },
        bottom: { url: '', in_card: false },
    };
}

function emptyBannerFlags() {
    return { top: false, bottom: false };
}

export default {
    data() {
        return {
            colorFields: PERSONALIZABLE_COLOR_KEYS,
            defaults: DEFAULT_MODULE_COLORS,
            formColors: emptyFormColors(),
            formBanners: emptyFormBanners(),
            bannerSlots: [
                { position: 'top', label: 'Bandeau haut', uploadLabel: 'Importer l’image du bandeau haut' },
                { position: 'bottom', label: 'Bandeau bas', uploadLabel: 'Importer l’image du bandeau bas' },
            ],
            bannerUploading: emptyBannerFlags(),
            bannerRemoving: emptyBannerFlags(),
            bannerReplace: emptyBannerFlags(),
            bannerErrors: { top: '', bottom: '' },
            loading: false,
            loadError: false,
            saving: false,
            saveError: '',
            saveSuccess: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    async mounted() {
        if (!this.mainStore.authAdmin.hasSuperAdminRights) {
            this.$router.push({ name: 'Administration' });
            return;
        }
        await this.load();
    },
    methods: {
        swatchColor(key) {
            const value = (this.formColors[key] || '').trim();
            if (value) {
                return value;
            }
            return this.defaults[key] || '#ffffff';
        },
        buildBannersPayload() {
            return {
                top: { in_card: !!this.formBanners.top.in_card },
                bottom: { in_card: !!this.formBanners.bottom.in_card },
            };
        },
        mergePersonalizationFromApi(colors, banners) {
            const merged = { ...(colors || {}) };
            if (banners) {
                if (banners.banner_top_url) merged.banner_top_url = banners.banner_top_url;
                if (banners.banner_bottom_url) merged.banner_bottom_url = banners.banner_bottom_url;
                if (Object.prototype.hasOwnProperty.call(banners, 'banner_top_in_card')) {
                    merged.banner_top_in_card = banners.banner_top_in_card;
                }
                if (Object.prototype.hasOwnProperty.call(banners, 'banner_bottom_in_card')) {
                    merged.banner_bottom_in_card = banners.banner_bottom_in_card;
                }
            }
            return merged;
        },
        buildPersonalizationPayload() {
            const payload = {};
            PERSONALIZABLE_COLOR_KEYS.forEach(({ key }) => {
                payload[key] = (this.formColors[key] || '').trim();
            });
            return withSyncedPrimaryDark(payload);
        },
        buildPreviewPersonalization() {
            const payload = {};
            PERSONALIZABLE_COLOR_KEYS.forEach(({ key }) => {
                const value = (this.formColors[key] || '').trim();
                if (value) {
                    payload[key] = value;
                }
            });
            return withSyncedPrimaryDark(payload);
        },
        onPreview() {
            applyModuleTheme(this.mainStore.module.base, this.buildPreviewPersonalization());
        },

        clearField(key) {
            this.formColors[key] = '';
            this.onPreview();
        },
        fillFormFromApi(colors) {
            const next = emptyFormColors();
            PERSONALIZABLE_COLOR_KEYS.forEach(({ key }) => {
                if (colors && colors[key]) {
                    next[key] = colors[key];
                }
            });
            if (!next.primary && colors?.primary_dark) {
                next.primary = colors.primary_dark;
            }
            this.formColors = next;
        },
        fillBannersFromApi(banners) {
            const next = emptyFormBanners();
            if (banners?.banner_top_url) {
                next.top.url = banners.banner_top_url;
            }
            if (banners?.banner_bottom_url) {
                next.bottom.url = banners.banner_bottom_url;
            }
            if (Object.prototype.hasOwnProperty.call(banners || {}, 'banner_top_in_card')) {
                next.top.in_card = !!banners.banner_top_in_card;
            }
            if (Object.prototype.hasOwnProperty.call(banners || {}, 'banner_bottom_in_card')) {
                next.bottom.in_card = !!banners.banner_bottom_in_card;
            }
            this.formBanners = next;
            this.bannerReplace = emptyBannerFlags();
            this.bannerErrors = { top: '', bottom: '' };
        },
        startReplaceBanner(position) {
            this.bannerReplace[position] = true;
            this.bannerErrors[position] = '';
        },
        async uploadBanner(position, file) {
            this.bannerErrors[position] = '';
            if (!file) {
                return;
            }
            if (file.size > 2000000) {
                this.bannerErrors[position] = 'Le fichier ne doit pas dépasser 2 Mo.';
                return;
            }
            this.bannerUploading[position] = true;
            const id_module = this.mainStore.module.id;
            const res = await AdminService.uploadModulePersonalizationBanner(file, id_module, position);
            this.bannerUploading[position] = false;
            if (!res || res.error || !res.url) {
                this.bannerErrors[position] = res?.error || 'Envoi de l’image impossible.';
                return;
            }
            this.formBanners[position].url = res.url;
            this.bannerReplace[position] = false;
            this.mainStore.module.personalization = {
                ...this.mainStore.module.personalization,
                ...(res.personalization || {}),
            };
        },
        async removeBanner(position) {
            this.bannerErrors[position] = '';
            this.bannerRemoving[position] = true;
            const payload = {
                id_module: this.mainStore.module.id,
                colors: {},
                banners: {
                    [position]: { remove_image: true, in_card: this.formBanners[position].in_card },
                },
            };
            const res = await AdminService.saveModulePersonalization(payload);
            this.bannerRemoving[position] = false;
            if (!res || res.error) {
                this.bannerErrors[position] = res?.error || 'Suppression impossible.';
                return;
            }
            this.formBanners[position].url = '';
            this.bannerReplace[position] = false;
            const merged = {
                ...this.mainStore.module.personalization,
                ...this.mergePersonalizationFromApi(res.colors, res.banners),
            };
            delete merged[`banner_${position}_url`];
            this.mainStore.module.personalization = merged;
        },
        async load() {
            this.loading = true;
            this.loadError = false;
            const id_module = this.mainStore.module.id;
            const res = await AdminService.getModulePersonalization(id_module);
            if (res === false) {
                this.loadError = true;
                this.loading = false;
                return;
            }
            this.fillFormFromApi(res.colors || {});
            this.fillBannersFromApi(res.banners || {});
            this.loading = false;
        },
        async save() {
            this.saving = true;
            this.saveError = '';
            this.saveSuccess = false;
            const payload = {
                id_module: this.mainStore.module.id,
                colors: this.buildPersonalizationPayload(),
                banners: this.buildBannersPayload(),
            };
            const res = await AdminService.saveModulePersonalization(payload);
            this.saving = false;
            if (!res || res.error) {
                this.saveError = res?.error || 'Enregistrement impossible.';
                return;
            }
            this.mainStore.module.personalization = {
                ...this.mainStore.module.personalization,
                ...this.mergePersonalizationFromApi(res.colors, res.banners),
            };
            this.fillFormFromApi(res.colors || {});
            this.fillBannersFromApi(res.banners || {});
            applyModuleTheme(this.mainStore.module.base, this.mainStore.module.personalization);
            this.saveSuccess = true;
        },
    },
    beforeUnmount() {
        applyModuleTheme(this.mainStore.module.base, this.mainStore.module.personalization);
    },
};
</script>

<style lang="scss" scoped>
.color-row {
    border: 1px solid var(--spo-blue-grey, #e9edf4);
    background-color: var(--spo-light, #f6f8fd);
}

.color-swatch {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
}

.banner-preview {

    max-height: 160px;
    width: auto;
    height: auto;
    border-radius: 4px;
    border: 1px solid var(--spo-blue-grey, #e9edf4);
}
</style>
